import {
  Typography, Grid, Box,
} from "@material-ui/core"; // Material-UI components
import PropTypes from "prop-types"; // PropTypes for type checking
import { connect } from "react-redux"; // Redux connect for state management
import moment from "moment"; // Moment.js for date and time formatting
import React, { useState } from "react"; // React library and useState hook
import styles from "assets/jss/material-dashboard-react/components/businessForm"; // Custom styles
import { makeStyles } from "@material-ui/core/styles"; // Material-UI makeStyles for custom styling
import Card from "components/Card/Card"; // Custom Card component
import { emptyReduxState } from "Redux/Actions/merchantInformation"; // Redux action to reset state
import CheckCircleIcon from "@material-ui/icons/CheckCircle"; // Success icon
import CancelIcon from "@material-ui/icons/Cancel"; // Failure icon
import PrintIcon from "@material-ui/icons/Print"; // Print icon
import ArrowBackIcon from "@material-ui/icons/ArrowBack"; // Back icon
import { withStyles } from "@material-ui/styles"; // Material-UI withStyles for custom tooltips
import Tooltip from "@material-ui/core/Tooltip"; // Material-UI Tooltip component

// Custom styles for tooltips
const useStyles = makeStyles(styles);
const IconsTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#000", // Black background for tooltips
    fontSize: "12px", // Font size for tooltips
  },
  tooltipPlacementTop: {
    margin: "4px 0", // Margin for tooltips placed at the top
  },
}))(Tooltip);

function PaymentCompletePage(props) {
  const classes = useStyles(); // Initialize custom styles
  const [data, setData] = useState(null); // State to store transaction data

  // Function to handle closing the page and navigating back
  const handelClose = () => {
    const keyToRemove = "transactionData"; // Key for transaction data in localStorage
    localStorage.removeItem(keyToRemove); // Remove transaction data from localStorage
    props.history.push(`/${props.app.app.layout}/makePayment`); // Navigate to the make payment page
  };

  // Function to handle printing the page
  const handlePrint = () => {
    window.print(); // Trigger the browser's print functionality
  };

  // Effect to fetch transaction data from localStorage on component mount
  React.useEffect(() => {
    const dataFromStorage = localStorage.getItem("transactionData"); // Get transaction data from localStorage
    if (dataFromStorage) {
      const parsedData = JSON.parse(dataFromStorage); // Parse the JSON data
      setData(parsedData); // Set the parsed data in state
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="dashboardTiles" style={{ position: "relative" }}>
      <Card>
        {/* Header with back and print icons */}
        <div style={{
          width: "99%", display: "flex", justifyContent: "space-between", padding: "5px",
        }}>
          <IconsTooltip title="Back" placement="top">
            <ArrowBackIcon fontSize="large" color="primary" onClick={handelClose} />
          </IconsTooltip>
          <IconsTooltip title="Print" placement="top">
            <PrintIcon fontSize="large" color="primary" onClick={handlePrint} />
          </IconsTooltip>
        </div>
        <Grid container>
          <Grid item xs={2} />
        </Grid>
        <Grid container>
          <Grid item xs={2} />
          <Grid item xs={12} style={{ textAlign: "center" }}>
            {data?.completed === true ? (
              <CheckCircleIcon style={{ fontSize: "75px", color: "#3aae3a" }} />
            ) : (
              <CancelIcon style={{ fontSize: "75px", color: "#ff0a0a" }} />
            )}
          </Grid>
          <Grid item xs={2} />
        </Grid>

        {/* Transaction details */}
        <Box>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                fontSize: "16px",
                color: "#3a57a7",
                fontFamily: "Source Sans Pro",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div style={{ textAlign: "center" }}>
                  {" "}
                  {data?.completed === true ? "Thank you" : " Payment Failed"}
                </div>
                <br />
                <div>
                  {"Your payment of "}
                  <b style={{ fontSize: "22px" }}>
                    $
                    {data?.amount}
                  </b>
                  {" "}
                  with transaction Id.
                  {" "}
                  <b style={{ fontSize: "22px" }}>{data?.transactionId}</b>
                  {" "}
                  has
                  {" "}
                  {data?.completed === true
                    ? "been processed successfully."
                    : "failed. Please try again."}
                  <br />
                  <br />
                </div>
              </div>
            </Grid>

            {/* Display additional transaction details */}
            <Grid container spacing="auto">
              <Grid item lg={2} md={2} sm="auto" xs="auto" />
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderHading}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyLabel}>
                    Account Number
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderValue}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyValue}>
                    {data?.accountNumber}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderHading}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyLabel}>
                    Status
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderValue}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyValue}>
                    {data?.transactionStatus}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={2} md={2} sm="auto" xs="auto" />
            </Grid>

            {/* Additional details like recipient name, time, and amount */}
            <Grid container spacing="auto">
              <Grid item lg={2} md={2} sm="auto" xs="auto" />
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderHading}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyLabel}>
                    Recipient Name
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderValue}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyValue}>
                    {data?.recipientTitle}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderHading}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyLabel}>
                    Time (EDT)
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{ marginTop: "0px" }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderValue}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyValue}>
                    {moment(data?.timestamp).tz("America/New_York").format("MM/DD/YYYY hh:mm A")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={2} md={2} sm="auto" xs="auto" />
            </Grid>
            <Grid container spacing="auto">
              <Grid item lg={2} md={2} sm="auto" xs="auto" />
              <Grid
                item
                style={{
                  marginTop: "0px",
                  borderBottom: "1px solid rgba(0,0,0,0.32)",
                }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderHading}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyLabel}>
                    Amount (
                    {data?.currency}
                    )
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{
                  marginTop: "0px",
                  borderBottom: "1px solid rgba(0,0,0,0.32)",
                }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderValue}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyValue}>
                    {data?.amount}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{
                  marginTop: "0px",
                  borderBottom: "1px solid rgba(0,0,0,0.32)",
                }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderHading}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyLabel}>
                    Txn ID
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                style={{
                  marginTop: "0px",
                  borderBottom: "1px solid rgba(0,0,0,0.32)",
                }}
                lg={2}
                md={2}
                sm={6}
                xs={6}
                sx={{ mt: 2 }}
                className={classes.girdBorderValue}
              >
                <Box className={classes.customBoxEWay}>
                  <Typography className={classes.customTypographyValue}>
                    {data?.transactionId}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={2} md={2} sm="auto" xs="auto" />
            </Grid>
            {data?.fee && (
              <Grid container spacing="auto">
                <Grid item lg={2} md={2} sm="auto" xs="auto" />
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderHading}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyLabel}>
                      Fee (
                      {data?.currency}
                      )
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderValue}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyValue}>
                      {data?.fee}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderHading}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyLabel}>
                      {data?.feeTransactionStatus === "Completed"
                        ? "Fee Txn ID"
                        : "Fee Status"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderValue}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyValue}>
                      {data?.feeTransactionStatus === "Completed"
                        ? data?.feeTransactionId
                        : data?.feeTransactionStatus}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={2} md={2} sm="auto" xs="auto" />
              </Grid>
            )}
            {data?.refund && (
              <Grid container spacing="auto">
                <Grid item lg={2} md={2} sm="auto" xs="auto" />
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderHading}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyLabel}>
                      Refunded (
                      {data?.currency}
                      )
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderValue}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyValue}>
                      {data?.refund}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderHading}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyLabel}>
                      {data?.refundTransactionStatus === "Completed"
                        ? "Refund Txn ID"
                        : "Refund Status"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: "0px",
                    borderBottom: "1px solid rgba(0,0,0,0.32)",
                  }}
                  lg={2}
                  md={2}
                  sm={6}
                  xs={6}
                  sx={{ mt: 2 }}
                  className={classes.girdBorderValue}
                >
                  <Box className={classes.customBoxEWay}>
                    <Typography className={classes.customTypographyValue}>
                      {data?.refundTransactionStatus === "Completed"
                        ? data?.refundTransactionId
                        : data?.refundTransactionStatus}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={2} md={2} sm="auto" xs="auto" />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              style={{
                fontSize: "16px",
                color: "#3a57a7",
                fontFamily: "Source Sans Pro",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div>
                  <p>You may close this window.</p>
                  <br />
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </div>
  );
}

PaymentCompletePage.propTypes = {
  history: PropTypes.object, // React Router history object for navigation
};

// Map Redux state to component props
const mapStateToProps = app => ({
  userData: app.userDetails, // Map user details from Redux state
  app,
  formData: app,
  sendMoneyData: app.merchantInformation.sendMoneyData,
});

// Connect component to Redux and export
export default connect(mapStateToProps, {
  emptyReduxState, // Redux action to reset state
})(PaymentCompletePage);
